import { FutureValuesSettings } from './future-values-settings.model';
import { ValuationSettings } from './valuation-settings.model';
import { ReportValuesSource } from 'app/report/enums/report-values-source';

export class ReportRequest {
    title: string;
    files: Array<File>;
    conditionType: number;
    datasetDate: string;
    isDefaultDataset: boolean;
    compareToDatasetDates: Array<string>;
    reportValuesSource: ReportValuesSource;
    todaysDate: string;
    reportTypeId: number;
    reportTypeName: string;
    alwaysUseCurrentDataset: boolean;
    valuationSettings: ValuationSettings;
    vehicleConditionName: string;
    compareAgainstFieldId: number;
}



// WEBPACK FOOTER //
// ./src/app/report/models/report-request.model.ts